import {doc} from '../docs.js';
import {float} from './utils.js';
import {hashCode} from "utils/hashCode.js";
import {lazy} from './lazy.js';
import {extractCode} from './extract.js';

doc(
    "gl.uniform",
    {
        "value": "",
        "name": "",
        "skipRender": "",
    },
    "Creates a new uniform variable with value from left-inlet, in GLSL.",
    () => 1,
    {
        tags: "GLSL",
        inlets: 3
    });

export const gl_uniform = (object, name, skipRender) => {
    object.needsHotReload = true;
    object.needsLoad = true;

    let uniforms = {};
    object.uniforms = uniforms;;
    let obj = {};
    let counter=0;
    let _name = undefined;
    let lastVal = undefined;
    return ([val], force) => {
        let _skipRender = skipRender ? skipRender() : false;
        let og = val;
        if (val === "start") {
            if (lastVal === undefined) {
                val = 0;
            } else {
                val = lastVal;
                return;
            }
        } 
        if (val === "bang") {
            val = 0;
        }
        if (_name !== name()) {
            counter = 0;
        }
        _name = name();

        lastVal = val;

        if (uniforms[name()]) {
            uniforms[name()].value = val;
            let _update = uniforms[name()].update || window.fallBackUpdate[name()];
            if (_update) {
                _update(val, _skipRender);
                if (!force) {
                    return;
                }
            } else {
            }
        } else {
            uniforms[name()] = {
                value: val
            };
        }
        obj.code = name();
        obj.uniforms = uniforms;
        obj.hashCode = hashCode(obj.code);
        // object.flash();
        return obj;
    };
};


doc(
    "gl.variable",
    {
        "value": "",
        "name": "",
        "type": "",
    },
    "Creates a new uniform variable with value from left-inlet, in GLSL.",
    () => 1,
    {
        tags: "GLSL",
        inlets: 3
    });

export const gl_variable = (object, name, type) => {
    object.needsHotReload = true;

    let uniforms = {};
    let obj = {};
    let counter=0;
    let _name = undefined;
    return ([val]) => {
        obj.code = name();
        if (val && val.uniforms) {
            obj.uniforms = val.uniforms;
        } else {
            obj.uniforms ={};
        }
        if (val && val.functions) {
            obj.functions = val.functions;
        }
        if (val && val.variables) {
            obj.variables = {... val.variables};
        } else {
            obj.variables = {};
        }
        obj.variables[name()] = {
            code: val && val.code ? val.code : float(val),
            type: type()
        };
        obj.hashCode = hashCode(obj.code);
        object.flash();
        return obj;
    };
};



